import { useApi } from '@/api';
import {
  Page,
  PageSkeleton,
  ActivityCard,
  Asset,
  SparkTitle,
  WalletHeading
} from '@/components';
import HistoricGraphs from './HistoricGraphs';
import { useParams } from 'react-router';
import { Flex, KpiCard } from '@blockanalitica/ui';

type MarketWallet = {
  underlying_symbol: string;
  underlying_address: string;
  wallet_info: {
    total_supply: string | null;
    total_borrow: string | null;
    health_rate: string | null;
  };
};

export default function MarketWalletPage() {
  const { network, marketAddress, walletAddress } = useParams() as {
    network: string;
    marketAddress: string;
    walletAddress: string;
  };

  const [data, error] = useApi<MarketWallet>({
    url: `/markets/${marketAddress}/wallets/${walletAddress}/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <PageSkeleton />;
  }

  return (
    <Page>
      <WalletHeading
        walletAddress={walletAddress}
        totalSupply={data.wallet_info.total_supply}
        totalBorrow={data.wallet_info.total_borrow}
        healthRate={data.wallet_info.health_rate}
        network={network}
      />

      <SparkTitle>
        <Asset
          symbol={data.underlying_symbol}
          address={data.underlying_address}
          network={network}
          iconSize="4"
          fontSize="3"
        />
      </SparkTitle>

      <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
        <KpiCard
          title="Supplied"
          data={data}
          field="supply"
          options={{
            notation: 'compact',
            currency: {
              name: data.underlying_symbol,
              address: data.underlying_address,
              network: network
            }
          }}
        />

        <KpiCard
          title="Borrowed"
          data={data}
          field="borrow"
          options={{
            notation: 'compact',
            currency: {
              name: data.underlying_symbol,
              address: data.underlying_address,
              network: network
            }
          }}
        />
      </Flex>
      <HistoricGraphs
        marketAddress={data.underlying_address}
        underlyingSymbol={data.underlying_symbol}
        network={network}
        walletAddress={walletAddress}
      />
      <ActivityCard
        url={`/markets/${marketAddress}/wallets/${walletAddress}/heatmap/`}
        linkTo="activity"
        onClickUrl={`activity`}
      />
    </Page>
  );
}
